import Vue from 'vue';
import Router from 'vue-router';

import ApplicationFormPage from 'vues/shopping-order/components/pages/ApplicationFormPage';
import CartPage from 'vues/shopping-order/components/pages/CartPage';
import CompletedPage from 'vues/shopping-order/components/pages/CompletedPage';
import ProductListPage from 'vues/shopping-order/components/pages/ProductListPage';
import PaymentPage from 'vues/shopping-order/components/pages/PaymentPage';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      component: ProductListPage,
      beforeEnter: (to, from, next) => {
        // console.log(`to.path: ${to.path} from.path: ${from.path}`);
        next();
      },
    },
    {
      path: '/cart',
      component: CartPage,
      beforeEnter: (to, from, next) => {
        // console.log(`to.path: ${to.path} from.path: ${from.path}`);
        if (from.path === '/' || from.path === '/application-form') {
          next();
        } else {
          next('/');
        }
      },
    },
    {
      path: '/application-form',
      component: ApplicationFormPage,
      beforeEnter: (to, from, next) => {
        // console.log(`to.path: ${to.path} from.path: ${from.path}`);
        if (from.path === '/cart' || from.path === '/payment') {
          next();
        } else {
          next('/');
        }
      },
    },
    {
      path: '/payment',
      component: PaymentPage,
      beforeEnter: (to, from, next) => {
        // console.log(`to.path: ${to.path} from.path: ${from.path}`);
        if (from.path === '/application-form') {
          next();
        } else {
          next('/');
        }
      },
    },
    {
      path: '/completed',
      component: CompletedPage,
      beforeEnter: (to, from, next) => {
        if (from.path === '/payment') {
          next();
        } else {
          next('/');
        }
      },
    },
  ],
  /**
   * 参考：https://codekneading.com/blog/2019/11/vue-router-scroll-position.html#%E6%A6%82%E8%A6%81
   * @param {} to
   * @param {*} from
   * @param {*} savedPosition
   * @returns
   */
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // return new Promise((resolve, reject) => {
      //   setTimeOut(() => {
      //     resolve(savedPosition);
      //   });
      // });
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
